// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__CcKYQ","link--small":"Link_link--small__thRHO","link--medium":"Link_link--medium__Zt__M","link--large":"Link_link--large__3_4ob"};